import type {FC, ReactNode} from 'react';
import {Box, Typography} from '@wellstone-solutions/web';
import {headerPalette} from './palette';

// Below this a value always fits, so a tooltip would just repeat it
const SHORT_VALUE_LENGTH = 24;

interface InfoFieldProps {
  label: string;
  children: ReactNode;
  truncate?: boolean;
}

export const InfoField: FC<InfoFieldProps> = ({label, children, truncate}) => (
  <Box sx={{minWidth: 0}}>
    <Typography sx={styles.label}>{label}</Typography>
    {typeof children === 'string' ? (
      <Typography
        sx={
          truncate ? {...styles.value, ...styles.valueTruncated} : styles.value
        }
        title={
          truncate && children.length > SHORT_VALUE_LENGTH
            ? children
            : undefined
        }>
        {children}
      </Typography>
    ) : (
      children
    )}
  </Box>
);

const styles = {
  label: {
    color: headerPalette.textSecondary,
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: 1,
    marginBottom: '4px',
    textTransform: 'uppercase',
  },
  value: {
    color: headerPalette.textPrimary,
    fontSize: 16,
    overflowWrap: 'anywhere',
  },
  valueTruncated: {
    overflow: 'hidden',
    overflowWrap: 'normal',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};
